import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom'
import Article from './ui/Article.js'
import Section from './ui/Section.js'
import ReactMarkdown from 'react-markdown';
import fm from 'front-matter';

class PackageSection extends Component {
    render() {
        let descriptor = this.props.descriptor;
        return (
            <li className="mt-4">
                <h3><Link to={`${this.props.baseUrl}/${descriptor.fullName}`}>{descriptor.fullName}</Link></h3>
                <p>{descriptor.package.summary}</p>
            </li>
        )
    }
}

class Overview extends Component {
    render() {
        /*
            FIXME: Don't depend on webpack details here
            https://github.com/facebook/create-react-app/issues/1944#issuecomment-316081906
        */
        const data = fm(require(`!raw-loader!./content/overview.md`));
        return (
            <Article kind="RPC Reference" title={data.attributes.title} subtitle={data.attributes.subtitle}>
                <Section title="Overview">
                    <ReactMarkdown source={data.body} />
                </Section>
                <Section title="Packages">
                    <ul className="list-unstyled">
                        {this.props.store.packageNames().map((packageName) => (
                            <PackageSection descriptor={this.props.store.descriptor(packageName)} baseUrl={this.props.baseUrl} />
                        ))}
                    </ul>
                </Section>
            </Article>
        );
    }

}

export default Overview;



// WEBPACK FOOTER //
// ./src/reference/Overview.js